module.exports = __webpack_public_path__ + "cc01b61702dbc56e0c48e41a3c73b90d.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/jenna-zeigen.jpg
 ** module id = 413
 ** module chunks = 0
 **/